import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ManageYieldService } from 'src/app/services/manage-yield.service';

@Component({
  selector: 'smart-manage-yield-view',
  templateUrl: './manage-yield-view.component.html',
  styleUrls: ['./manage-yield-view.component.scss','../../platform-color/platform-color.css']
})
export class ManageYieldViewComponent implements OnInit {
  status: string = "";
  farm_id: string = "";
  yield_template_id: string = "";

  yieldData: any;
  constructor(
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private ManageYieldService: ManageYieldService,

    private cd: ChangeDetectorRef
  ) { 
    this.route.queryParams
    .subscribe(params => {
      this.status = params.status;
      this.farm_id = params.farm_id;
    }
  );
  this.yield_template_id = 
  this.route.snapshot.paramMap.get("yield_template_id");
  }

  ngOnInit(): void {
    if(this.status == 'Master'){
      this.getMainYieldTemplate();
    }else{
      this.getYieldTemplate();
    }
  }

  async getMainYieldTemplate(){
    this.spinner.show();
    this.ManageYieldService.getMainYieldTemplatesById(this.yield_template_id).subscribe(res=>{
      this.yieldData = res.data[0];

      this.spinner.hide();
      this.cd.detectChanges();
    })
  }

  async getYieldTemplate(){
    this.spinner.show();
    this.ManageYieldService.getYieldTemplatesById(this.yield_template_id).subscribe(res=>{
      this.yieldData = res.data[0];

      this.spinner.hide();
      this.cd.detectChanges();
    })
  }
}
